import React, { Fragment } from "react";
import Modal from "../Modal";
import Button from "../../Resources/Forms/Button";

const ConfirmModal = props => (
	<Modal
		closeModal={props.close}
		isSmall={true}
		width={props.width || "400px"}
		isHeaderClose={!props.hideClose}
		isLight={props.isLight}
	>
		<div
			className="header center"
			style={{ marginBottom: "5px", marginTop: "10px", lineHeight: "1.35" }}
			dangerouslySetInnerHTML={{ __html: props.header }}
		/>
		{props.children ? (
			<div
				className="light center"
				style={{
					fontSize: "13px",
					marginBottom: "20px",
					marginTop: "-5px",
					lineHeight: "1.4",
				}}
			>
				{props.children}
			</div>
		) : (
			<Fragment>
				{props.subHeader && (
					<div
						className="light center"
						style={{
							fontSize: "13px",
							marginBottom: "20px",
							marginTop: "-5px",
							lineHeight: "1.4",
						}}
						dangerouslySetInnerHTML={{ __html: props.subHeader }}
					/>
				)}
			</Fragment>
		)}
		<div
			className="flex align-center"
			style={{
				maxWidth: "100%",
				margin: "10px auto 0px",
				justifyContent: "center",
			}}
		>
			{!props.hideCancelBtn && (
				<div style={{ marginRight: "15px" }}>
					<Button
						type={"btn--no-style"}
						text={props.cancelText || "Cancel"}
						onClick={props.cancel ? props.cancel : props.close}
						noMargin={true}
						disabled={props.loading}
					/>
				</div>
			)}
			<Button
				type={"primary"}
				onClick={props.confirm}
				noMargin={true}
				loading={props.loading}
				text={props.confirmText || "Confirm"}
			/>
		</div>
	</Modal>
);

export default ConfirmModal;
